import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { withActions } from "actionware";
import { getTranslate } from "react-localize-redux";
import { push } from "connected-react-router";
import { bindActionCreators } from "redux";
import * as _ from "lodash";

import LenderRank from "./fundingLimitComponents/lenderRank";
import { saveNewCycleData, resetToInitialState } from "./fundingLimitActions";
import { toggleConfirmationModal } from "../confirmationModal/confirmationModalActions";

import "./fundingLimit.less";
import { Button, Row } from "antd";
import {
  validateLenderRankingInputFieldsOnClickNext,
  removeInvalidMessageOnLenderRankingInputFieldChange,
} from "../fundingLimit/validations";
import HeaderWithArrow from "../../components/headerWithArrow/headerWithArrow";
import { modalPopupStates } from "../../common/constants";

@connect(
  ({ localize, funding: { action, products, lenders, newCycle } }) => ({
    translate: getTranslate(localize),
    action,
    products,
    lenders,
    newCycle,
  }),
  (dispatch) => {
    return bindActionCreators({ push }, dispatch);
  }
)
@withActions({
  saveNewCycleData,
  resetToInitialState,
  toggleConfirmationModal,
})
class LenderRanking extends PureComponent {
  constructor() {
    super();
    this.state = {
      lenderRankingValidations: new Map(),
    };
  }
  async componentWillMount() {
    this.handleInputFieldChange = this.handleInputFieldChange.bind(this);
    this.cancelClicked = this.cancelClicked.bind(this);
    this.saveChangesClicked = this.saveChangesClicked.bind(this);
    this.setValidationState = this.setValidationState.bind(this);
    this.checkValidations = this.checkValidations.bind(this);
    this.goNextState = this.goNextState.bind(this);

    if (this.props.isEditLenderRanking) {
      this.props.saveNewCycleData("editLenderRanking", {});
    }
  }

  componentDidMount() {
    const { newCycle } = this.props;
    this.setValidationState(newCycle);
  }

  componentDidUpdate() {
    const { newCycle, isEditLenderRanking } = this.props;
    const { lenderRankingValidations } = this.state;

    if (
      isEditLenderRanking &&
      _.isEmpty(lenderRankingValidations) &&
      !_.isEmpty(newCycle)
    ) {
      this.setValidationState(newCycle);
    }
  }

  componentWillUnmount() {
    this.setState({ lenderRankingValidations: new Map() });
  }

  goNextState = () => {
    const { isEditLenderRanking } = this.props;

    if (!isEditLenderRanking) {
      this.props.nextStepClicked();
    } else {
      this.saveChangesClicked();
    }
  };

  setValidationState = (newCycle) => {
    const initialValidationState = this.getInitialState(newCycle);
    this.setState(() => {
      return {
        lenderRankingValidations: initialValidationState,
      };
    });
  };

  getInitialState = (newCycle) => {
    const lenderRankingValidationsOuterMap = new Map();
    _.keys(newCycle).forEach((productKey) => {
      const product = newCycle[productKey];
      const lenderKeys = _.keys(product.lenders);
      const lenderRankingValidationsInnerMap = new Map();
      lenderKeys.forEach((lenderKey) => {
        lenderRankingValidationsInnerMap.set(lenderKey, {
          isInvalidInputAmount: false,
          isInvalidInputAmountMessage: "",
          isInvalidInputRank: false,
          isInvalidInputRankMessage: "",
          isDuplicateRankLender: false,
        });
      });
      lenderRankingValidationsOuterMap.set(productKey, {
        isTotalAmountExceeded: false,
        isTotalAmountExceededMessage: "",
        isDuplicateRankLenderPresentForProduct: false,
        lenderRankingValidationsMap: lenderRankingValidationsInnerMap,
      });
    });
    return lenderRankingValidationsOuterMap;
  };

  checkValidations = (
    newCycle,
    currentValidationState,
    isEditLenderRanking,
    translate
  ) => {
    let newValidationState = this.getInitialState(newCycle);
    if (
      validateLenderRankingInputFieldsOnClickNext(
        newCycle,
        newValidationState,
        isEditLenderRanking,
        translate
      )
    ) {
      this.goNextState();
    } else {
      this.setState((prevState) => {
        return {
          lenderRankingValidations: newValidationState,
        };
      });
    }
  };

  cancelClicked = () => {
    //reset the data in new cycle here
    this.props.resetToInitialState();
  };

  saveChangesClicked = () => {
    //make an action call for put request to send editted lender ranking data
    this.props.toggleConfirmationModal(modalPopupStates.editCurrentCycle);
  };

  handleInputFieldChange = (action, productID, lenderID, value) => {
    let updateValidationState = this.state.lenderRankingValidations;
    // This removes invalid message for input field only when the existing value is invalid. It returns true if it removes something
    if (
      removeInvalidMessageOnLenderRankingInputFieldChange(
        action,
        productID,
        lenderID,
        updateValidationState,
        this.props.newCycle
      )
    ) {
      this.setState((prevState) => {
        return { lenderRankingValidations: updateValidationState };
      });
    }

    this.props.saveNewCycleData(action, {
      productID,
      lenderID,
      value,
    });
  };

  backToLandingPage = () => {
    this.props.resetToInitialState();
  };

  checkForNoAvailableValueForEditCycle = () => {
    const { isEditLenderRanking, newCycle } = this.props;
    if (!isEditLenderRanking) {
      return false;
    }
    const keys = _.keys(newCycle);
    const canFundLenders = keys.map((key) => {
      const keyLender = _.keys(newCycle[key].lenders);
      return keyLender.map((lender) => {
        if (newCycle[key].lenders[lender].can_fund) {
          return lender;
        }
      });
    });

    return canFundLenders.length > 0 ? false : true;
  };

  renderEditLenderRankingButtons = () => {
    const { isEditLenderRanking, translate, newCycle } = this.props;
    if (isEditLenderRanking) {
      return (
        <>
          <div className="setup-funding-cycle-container show-lender-ranking-btns edit-lender-ranking-btn-container">
            <div className="edit-lender-ranking-header">
              <HeaderWithArrow
                title={translate(
                  `fundingLimit.ovo_admin_heading_edit_lender_ranking_funding_limit`
                )}
                showArrow={true}
                arrowClicked={this.backToLandingPage}
              />
            </div>
            <div className="edit-lender-ranking-header edit-lender-ranking-btn-container">
              <Button type="secondary" onClick={this.cancelClicked}>
                {translate("fundingLimit.cancel")}
              </Button>
              <Button
                type="primary"
                disabled={this.checkForNoAvailableValueForEditCycle()}
                onClick={() => {
                  this.checkValidations(
                    newCycle,
                    this.state.lenderRankingValidations,
                    isEditLenderRanking,
                    translate
                  );
                }}
              >
                {translate("fundingLimit.button_save_changes")}
              </Button>
            </div>
          </div>
          <Row className='edit-lender-ranking-sub-header'>{this.props.translate('fundingLimit.ovo_admin_body_edit_lender_ranking_funding_limit')}</Row>
         </>
      );
    }
  };

  renderLenderRankingCards = () => {
    const { newCycle, translate } = this.props,
      keys = _.keys(newCycle);
    return keys.map((key) => {
      if (newCycle[key].product_limit_snapshot > 0) {
        return (
          <LenderRank
            isEditLenderRanking={this.props.isEditLenderRanking}
            handleInputFieldChange={this.handleInputFieldChange}
            productLender={newCycle[key]}
            translate={translate}
            isTotalAmountExceeded={
              this.state.lenderRankingValidations.has(key)
                ? this.state.lenderRankingValidations.get(key)
                    .isTotalAmountExceeded
                : false
            }
            isTotalAmountExceededMessage={
              this.state.lenderRankingValidations.has(key)
                ? this.state.lenderRankingValidations.get(key)
                    .isTotalAmountExceededMessage
                : false
            }
            lenderRankAllValidations={
              this.state.lenderRankingValidations.has(key)
                ? this.state.lenderRankingValidations.get(key)
                    .lenderRankingValidationsMap
                : new Map()
            }
          />
        );
      } else {
        return <></>;
      }
    });
  };

  renderButtonForNavigation = () => {
    const { translate, prevStepClicked, isEditLenderRanking, newCycle } =
      this.props;
    if (!isEditLenderRanking) {
      return (
        <>
          <Button type="secondary" onClick={prevStepClicked}>
            {translate("fundingLimit.back")}
          </Button>
          <Button
            type="primary"
            onClick={() => {
              this.checkValidations(
                newCycle,
                this.state.lenderRankingValidations,
                isEditLenderRanking,
                translate
              );
            }}
          >
            {translate("fundingLimit.button_next")}
          </Button>
        </>
      );
    }
    return <></>;
  };

  renderPageContent = () => {
    return (
      <>
        {!this.props.isEditLenderRanking ? <Row className='lender-ranking-sub-header'>{this.props.translate('fundingLimit.ovo_admin_body_rank_lenders_enter_allocated_amt')}</Row> : <></>}
        {this.renderEditLenderRankingButtons()}
        {this.renderLenderRankingCards()}
        {this.renderButtonForNavigation()}
      </>
    );
  };

  render() {
    return <div>{this.renderPageContent()}</div>;
  }
}

export default LenderRanking;
